import { render, staticRenderFns } from "./Trasladoentrada.vue?vue&type=template&id=27e49f8c&"
import script from "./Trasladoentrada.vue?vue&type=script&lang=js&"
export * from "./Trasladoentrada.vue?vue&type=script&lang=js&"
import style0 from "./Trasladoentrada.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports